// extracted by mini-css-extract-plugin
export default {"ErrorPages-redirects-description":"ErrorPages-redirects-description23GkxCnp96rh","ErrorPages-redirects-input":"ErrorPages-redirects-inputU-_a8nUkbs6J"};